import { AppThunk } from "../store";
import { setUsers } from ".";
import { userService } from "services/userService";
import { ServiceOptions } from "services/baseService";

export const getAllUsers = (): AppThunk => async (dispatch) => {
  try {
    const options: ServiceOptions = {
      order: [["id", "ASC"]],
    };
    const { data } = await userService.getAll(options);
    dispatch(setUsers(data));
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getAllUsersWithSystemRoles = (): AppThunk => async (dispatch) => {
  try {
    const options: ServiceOptions = {
      include: ["Role"],
      order: [["id", "ASC"]],
    };
    const { data } = await userService.getAll(options);
    dispatch(setUsers(data));
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getAllUsersWithFilterRoles = (): AppThunk => async (dispatch) => {
  try {
    const options: ServiceOptions = {
      include: ["Profile"],
      order: [["id", "ASC"]],
    };
    const { data } = await userService.getAll(options);
    dispatch(setUsers(data));
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getUserById =
  (id: number): AppThunk =>
  async () => {
    try {
      const { data } = await userService.getById(id);
      return data;
    } catch (error) {
      console.error(error);
    }
  };
